<template>
  <div class="kangxin">
    <div class="kv">
      <img src="@/assets/family/senge/kv.png" alt="">
    </div>
    <HuaXing v-if="colorList.length > 0" :info="colorList" @next="next" :isloading="isloading" :showBtn="showBtn"></HuaXing>
    <div class="container">
      <img class="image" src="@/assets/family/senge/0.png" alt="">
    </div>

    <!-- <Sticky></Sticky> -->
    <!-- <section class="sticky-container" ref="stickyContainer">
      <div class="sticky-box">
        <div class="sticky-font">
          <img class="font-one" src="@/assets/family/kangxin/kangxinfont1.png" alt="">
          <img class="font-two" src="@/assets/family/kangxin/kangxinfont2.png" alt="">
        </div>
        <div ref="stickyImage"  class="sticky-content">
          <div class="showfont"></div>
          <img ref="stickyImage" class="sticky-image" src="@/assets/family/kangxin/kangxinsticky.png" alt="">
        </div>
      </div>
    </section> -->
    <!-- <img class="image" src="@/assets/family/kangxin/kangxin2.png" alt=""> -->
    <!-- <img class="image" src="@/assets/family/kangxin/kangxin3.jpg" alt=""> -->
  </div>
</template>

<script>
import { getGrainList } from '@/api/product'
import huaxing from '@/components/huaxing.vue'
import Sticky from '@/components/sticky.vue'
export default {
  name: 'Kangxin',
  components: {
    HuaXing: huaxing,
    Sticky
  },
  data() {
    return {
      isloading: false, // 加载中
      showBtn: true, // 更多
      form: {
        product_id: 10 ,
        pageNum: 1,
        pageSize: 8
      },
      colorList: []
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScrollX, true)
  },
  methods: {
    getList() {
      this.isloading = true
      getGrainList({
        ...this.form
      }).then(res => {
        if (res.dataList && res.dataList.length > 0) {
          res.dataList.forEach(item => {
            item.mp_logo_pic ? item.mp_logo_pic = JSON.parse(item.mp_logo_pic) : []
          })
          this.colorList = [...this.colorList, ...res.dataList]
          if (res.dataList.length >= this.form.pageSize) {
            this.showBtn = true
          } else {
            this.showBtn = false
          }
        } else {
          this.showBtn = false
        }
        this.isloading = false
      })
    },
    next() {
      if (this.isloading) return
      this.form.pageNum++
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.kangxin {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  .kv {
    width: 100%;
    max-width: 1920px;
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
  .container {
		max-width: 1920px;
		margin: 0 auto;
		padding: 60px 220px;
		.image {
			width: 100%;
			vertical-align: top;
			display: block;
		}
	}
}
</style>
